"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
function SupplierRatingViewTab() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = (0, react_router_dom_1.useParams)();
    var supplierId = params.supplierId;
    var _a = (0, firestore_1.useCollection)(collectionsRef_1.supplierRatingsRef.where("supplierId", "==", supplierId)), snapshot = _a[0], loading = _a[1];
    if (loading) {
        return null;
    }
    var dataSource = snapshot.docs.map(function (e) {
        return __assign(__assign({}, e.data()), { id: e.id });
    });
    var columns = [
        {
            name: "rating",
            title: t("suppliers.rating"),
        },
        {
            name: "ratedProduct",
            title: t("suppliers.ratedProduct"),
        },
        {
            name: "ratedBy",
            title: t("suppliers.ratedBy"),
            getCellValue: function (r) {
                var _a;
                return (_a = usersList_1.globalUsersData[r.ratedBy]) === null || _a === void 0 ? void 0 : _a.name;
            },
        },
        {
            name: "ratedAt",
            title: t("suppliers.ratedAt"),
            getCellValue: function (r) {
                return r.ratedAt.toDate().toLocaleString();
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({ groups: true, filter: true }), true) })) }));
}
exports.default = SupplierRatingViewTab;
